import React, { useEffect, useState } from "react";
import BrandingHeader from "../../components/BrandingHeader";
import { db } from "../../firebase";

function Invitation() {
  const [mentors, setMentors] = useState([]);

  const getAllMentors = () => {
    return new Promise((resolve, reject) => {
      var query = db.collection("mentors");
      query
        .where("status", "==", true)
        .get()
        .then((snapshot) => {
          resolve(snapshot.docs.map((doc) => doc.data()));
        })
        .catch((error) => {
          reject(error);
          console.log("Error getting documents: ", error);
        });
    });
  };

  useEffect(() => {
    if (sessionStorage.getItem("mentorData") == null) {
      getAllMentors()
        .then((data) => {
          setMentors(data);
          sessionStorage.setItem("mentorData", JSON.stringify(data));
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      setMentors(JSON.parse(sessionStorage.getItem("mentorData")));
    }
  }, []);

  return (
    <div>
      <BrandingHeader />
      <div class="container px-5 py-24 mx-auto">
        <div class="lg:w-3/4 flex flex-col items-start mx-auto">
          <h1 class="sm:pr-16 text-5xl font-semibold title-font text-gray-900">
            We are so excited for you to join :)
          </h1>
          <p className="mt-8 text-xl">
            {" "}
            You need an invite from the existing mentor to be a mentor on Dev
            Colony.
          </p>
          <div>
            <a
              href="/faq"
              className="inline-flex mt-6 text-white font-base bg-gradient-to-r from-blue-500 to-blue-900 border-0 py-2 px-6 focus:outline-none rounded-lg text-md"
            >
              Read FAQ's
            </a>
            <a
              href="/member/setup"
              className="inline-flex mt-6 ml-2 text-white font-base bg-blue-400 hover:bg-blue-500 border-0 py-2 px-6 focus:outline-none rounded-lg text-md"
            >
              Join as Member
            </a>
          </div>
        </div>

        <div className="lg:w-3/4 flex flex-col sm:flex-row sm:items-center items-start mx-auto mt-4">
          <div class="mt-4">
            <h4 class="text-sm text-gray-600">Recently added Mentors</h4>
            <div class="flex items-center overflow-hidden mt-4">
              {mentors.slice(0, 8).map((item) => (
                <a
                  id={item}
                  href={`/mentor/${item.username}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    class="inline-block h-16 w-16 rounded-full text-white border-2 border-white object-cover object-center"
                    src={item.profilePic}
                    alt={item.name}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invitation;
